module.exports = __webpack_public_path__ + "54e00dfc1042979f8ddc135770540360.svg";